/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import axios from "axios";
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import CheckButton from "react-validation/build/button";
import CurrencyInput from "react-currency-input-field";
import Tooltip from "@tippyjs/react";
import SlidingPane from "react-sliding-pane";
import "tippy.js/dist/tippy.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaterialTable, { MTableToolbar } from "material-table";

import Helper from "../../../../Helper";
import { API } from "../../../../backend";
import AddContractService from "../../../../services/contract/addContractService";
import { getTrans as t } from "../../../../Localization/translations";
import authHeader from "../../../../services/auth-header";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import AddAssetService from "../../../../services/contract/asset/addAssetService";
import AddPaymentScheduleService from "../../../../services/contract/paymentSchedule/addPaymentScheduleService";
import EditItemMasterService from "../../../../services/itemmaster/itemmasterEditServices";
import AddItemmasterService from "../../../../services/itemmaster/itemmasterAddService";

function CreateRentalContract() {
  const location = useLocation();
  const states = location?.state;

  const [loading, setLoading] = useState(false);
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState(new Date());
  const [contract_term, setContract_term] = useState("");
  const [address, setAddress] = useState([]);
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState(states);
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [contract_number_method_disable, setContract_number_method_disable] =
    useState("");
  const [asset_type, setAssetType] = useState("");
  const [paymentrule, setPaymentRule] = useState("Advance");
  const [asset_typesetting, setAssetSettingType] = useState("");
  const [asset_typeselection, setAssetTypeSelection] = useState("");
  const [successful, setSuccessful] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    trigger,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [filedcontract, setFiledContract] = useState([
    { attribute0: "" },
    { attribute1: "" },
    { attribute2: "" },
    { attribute3: "" },
    { attribute4: "" },
    { attribute5: "" },
    { attribute6: "" },
    { attribute7: "" },
    { attribute8: "" },
    { attribute9: "" },
    { attribute10: "" },
    { attribute11: "" },
    { attribute12: "" },
    { attribute13: "" },
    { attribute14: "" },
  ]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");

  // add party customer
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();

  //party screen
  const [party_type, setParty_type] = useState("Customer");
  const [customer_type, setCustomer_type] = useState("Organization");
  const [showhide, setShowHide] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [establishment_date, setEstablishment] = useState(null);
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);

  //party screen
  const [party_typevendor, setParty_typeVendor] = useState("Vendor");
  const [customer_typevendor, setCustomer_typeVendor] =
    useState("Organization");
  const [customer_namevendor, setCustomer_nameVendor] = useState("");
  const [establishment_datevendor, setEstablishmentVendor] = useState(null);
  const [date_of_birthvendor, setDate_of_birthVednor] = useState(null);

  // Address Screen
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [country_name, setCountry_name] = useState([])
  const [vendor_country_name, setVendor_Country_name] = useState([])
  const [install_country_name, setInstall_Country_name] = useState([])
  const [state_name, setState] = useState([]);
  const [install_state_name, setInstall_State] = useState([]);
  const [vendor_state_name, setVendor_State] = useState([]);
  const [countryid, setCountryid] = useState("")
  const [vendorcountryid, setVendorCountryid] = useState("")
  const [installcountryid, setInstallCountryid] = useState("")
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("No");
  const [install_to, setInstall_to] = useState("Yes");

  const [vendoraddress_line_1, setVendorAddress_line_1] = useState("");
  const [vendoraddress_line_2, setVendorAddress_line_2] = useState("");
  const [vendorcity, setVendorCity] = useState("");
  const [vendorstateaddress, setVendorStateAddress] = useState("");
  const [vendorzip_code, setVendorZip_code] = useState("");
  const [vendorcountry, setVendorCountry] = useState("");
  const [vendorbill_to, setVendorBill_to] = useState("Yes");
  const [vendorship_to, setVendorShip_to] = useState("No");
  const [vendorinstall_to, setVendorInstall_to] = useState("Yes");
  // asset
  const [reg_address, setReg_address] = useState([]);
  const [installstateaddress, setInstallStateAddress] = useState("");
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    reset: reset3,
    formState: { errors: errors3 },
  } = useForm();
  const form3 = useRef();

  const form4 = useRef();
  const checkBtn4 = useRef();
  const {
    register: register4,
    handleSubmit: handleSubmit4,
    reset: reset4,
    formState: { errors: errors4 },
  } = useForm();

  const form5 = useRef();
  const checkBtn5 = useRef();
  const {
    register: register5,
    handleSubmit: handleSubmit5,
    reset: reset5,
    formState: { errors: errors5 },
  } = useForm();

  const [reg_address1, setReg_address1] = useState(null);
  const [vehicle_cost, setVehicle_cost] = useState(0);
  const [vendor_name, setVendorName] = useState([]);
  const [vendername1, setVendorName1] = useState(null);
  const [asset_number, setAsset_number] = useState("");
  const [asset_desc, setAsset_desc] = useState(null);
  const [license_number, setLicense_number] = useState(null);
  const [year, setYear] = useState(null);
  const [vin_number, setVin_number] = useState(null);
  const [license_state, setLicense_state] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [make, setMake] = useState(null);
  const [model, setModel] = useState(null);
  const [user_purpose, setUser_purpose] = useState(null);
  const [residal_value, setResidal_value] = useState(0);
  const [delivery_date, setDelivery_date] = useState(null);
  const [in_service_date, setIn_service_date] = useState(null);
  const [milage, setMilage] = useState(0);
  const [tax_amount, setTax_amount] = useState(0);
  const [tax_amount_payto, setTax_amount_payto] = useState("Dealer");
  const [trade_in, setTrade_in] = useState(0);
  const [trade_in_payto, setTrade_in_payto] = useState("Borrower");
  const [reg_cost, setReg_cost] = useState(0);
  const [reg_cost_payto, setReg_cost_payto] = useState("Dealer");
  const [down_payment, setDown_payment] = useState(0);
  const [down_payment_payto, setDown_payment_payto] = useState("Borrower");
  const [vehicle_cost_payto, setVehicle_cost_payto] = useState("Dealer");

  // payment
  const [payment_type, setPayment_type] = useState("Rent");
  const [no_of_payments, setNo_of_payments] = useState(null);
  const [amount, setAmount] = useState(null);
  const [frequency, setFrequency] = useState("Monthly");
  const [paymentstart_date, setPaymentStart_date] = useState("");
  const [Paymentend_date, setPaymentEnd_date] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [pacakge, setPackage] = useState([]);
  const [companydata, setCompany] = useState([]);
  const [disablebutton, setDisablebutton] = useState(false);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([])

  const [selectedBill, setSelectedBill] = useState(null);
  const [filterBill, setFilterBill] = useState([])

  const [formData, setFormData] = useState({});
  const [isEquipment, setIsEquipment] = useState(false);

  const [rowsData, setRowsData] = useState([]);
  const [termError, setTermError] = useState('');

  const [paymentFrequency, setPaymentFrequency] = useState([
    { value: 1, label: 'Monthly' },
    { value: 3, label: 'Quarterly' },
    { value: 6, label: 'Semi-annual' },
    { value: 12, label: 'Annual' }
  ]
  )

  const toggleFields = () => {
    setIsExpanded(!isExpanded);
  };

  const isFirstDayOfMonth = (date) => {
    return date.getDate() === 1;
  };

  const setenddate = (no_of_payments) => {
    if (start_date === "") {
      return false;
    }

    var contractDateObj = new Date(start_date);
    const frequencyMapping = {
      Monthly: { months: 1 },
      Quarterly: { months: 3 },
      "Semi-annual": { months: 6 },
      Annual: { months: 12 },
    };
    let paymentStartDate, paymentEndDate;
    if (paymentrule === "Advance") {
      paymentStartDate = contractDateObj;
    } else if (paymentrule === "Arrears") {
      const cycleDelta = frequencyMapping[frequency];
      if (isFirstDayOfMonth(contractDateObj)) {
        paymentStartDate = new Date(contractDateObj);
        paymentStartDate = new Date(
          paymentStartDate.getFullYear(),
          paymentStartDate.getMonth() + cycleDelta.months,
          1
        );
        paymentStartDate.setDate(paymentStartDate.getDate() - 1)


      } else {
        paymentStartDate = new Date(contractDateObj);
        paymentStartDate.setMonth(
          paymentStartDate.getMonth() + cycleDelta.months
        );
        paymentStartDate.setDate(paymentStartDate.getDate() - 1)

      }
    }
    paymentEndDate = new Date(contractDateObj);
    paymentEndDate.setMonth(
      paymentEndDate.getMonth() + parseInt(contract_term)
    );
    paymentEndDate.setDate(paymentEndDate.getDate() - 1);

    setPaymentStart_date(Helper.DatePicker(paymentStartDate));
    if (paymentEndDate !== "Invalid Date") {
      setPaymentEnd_date(Helper.DatePicker(paymentEndDate));
    }
  };

  const getinstalladdress = async (id) => {
    if (id !== undefined) {
      if (selectedValue !== null) {
        const resst = await fetch(
          API +
          "parties/manage-address/" +
          selectedValue +
          "/?address_type=install_to",
          { headers: authHeader() }
        );
        const getst = await resst.json();
        setReg_address(await getst.data);
        setReg_address1(id);
        reset({
          address_id: id,
        });
      }
    } else {
      if (selectedValue !== null) {
        const resst = await fetch(
          API +
          "parties/manage-address/" +
          selectedValue +
          "/?address_type=install_to",
          { headers: authHeader() }
        );
        const getst = await resst.json();
        setReg_address(await getst.data);
        setReg_address1(await getst.data[0].id);
        reset({
          address_id: await getst.data[0].id,
        });
      }
    }
  };

  const [state1, setState1] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state2, setState2] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state4, setState4] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state3, setState3] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state5, setState5] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const form6 = useRef();
  const checkBtn6 = useRef();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    reset: reset6,
    // formState: { errors: errors5 },
  } = useForm();

  const [frequencyMapped, setFrequencyMapped] = useState({
    'Monthly': 1,
    'Quarterly': 3,
    'SemiAnnual': 6,
    'Annual': 12
  })
  const [paymentType, setPaymentType] = useState([])

  const handelDefault = async () => {
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
      headers: authHeader(),
    });
    const gtst = await rsst.json();
    setVendorName(await gtst);
  };

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };
  const handleshowhidevendor = (e) => {
    const getuser = e.target.value;
    setCustomer_typeVendor(e.target.value);
  };

  const handleAddress = (id) => {
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddress_line_1("");
          setAddress_line_2("");
          setCity("");
          setStateAddress("");
          setZip_code("");
        }
      })
    }
  };

  const handleAddressVendor = (id) => {
    form4.current.validateAll();
    if (checkBtn4.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        vendoraddress_line_1,
        vendoraddress_line_2,
        vendorcity,
        vendorstateaddress,
        vendorzip_code,
        vendorcountry,
        vendorbill_to,
        vendorship_to,
        vendorinstall_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setVendorAddress_line_1("");
          setVendorAddress_line_2("");
          setVendorCity("");
          setVendorStateAddress("");
          setVendorZip_code("");
        }
      })
    }
  };

  const handleparty = () => {
    form2.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn2.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(
        customer_type,
        party_type,
        customer_name
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setDisable(true);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleAddress(response.data.partyId);
          loadInitialOptions();
          reset({
            selectedValue: response.data.partyId,
          });
          setTimeout(() => {
            setSelectedValue(response.data.partyId);
            setState1({ isPaneOpen: false });
          }, 1000);
          setCustomer_name("");
          setCustomer_type("");
        } else {
          setLoading(false);
          setSuccessful(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };

  const handlepartydefault = () => {
    AddPartyService.partyvalidate(customer_name).then((response) => {
      if (response.data.success) {
        handleparty();
      } else {
        confirmAlert({
          title: "",
          message:
            `Party ${customer_name} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    })
  };

  const handleVendorparty = () => {
    form4.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn4.current.context._errors.length === 0) {
      if (date_of_birthvendor) {
        dateofbirth = Helper.DatePicker(date_of_birthvendor);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_datevendor) {
        establishmentDate = Helper.DatePicker(establishment_datevendor);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(
        customer_typevendor,
        party_typevendor,
        customer_namevendor
      ).then((response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          reset({
            vendorname1: response.data.partyId,
          });
          setVendorName1(response.data.partyId);
          handleAddressVendor(response.data.partyId);
          setTimeout(() => {
            handelDefault();
            setState4({ isPaneOpen: false });
          }, 1000);
          setCustomer_nameVendor("");
        } else {
          setLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };

  const handlepartyvendor = () => {
    AddPartyService.partyvalidate(customer_namevendor).then((response) => {
      if (response.data.success) {
        handleVendorparty();
      } else {
        confirmAlert({
          title: "",
          message:
            `Party ${customer_namevendor} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleVendorparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    })
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    if (value === null) {
      setSelectedValue(value);
      reset({
        selectedValue: value,
      });
      setAddress([]);
      setAdddressId("");
      setReg_address1("");
      setReg_address([]);
    } else {
      setSelectedValue(value.id);
      reset({
        selectedValue: value.id,
      });
      getaddress();
      getinstalladdress();
    }
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async () => {
    const responseJSON = await axios.get(
      API +
      `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
      { headers: authHeader() }
    );
    setOptions(responseJSON.data.data);
  };

  const contract_number_method = async () => {
    await axios
      .get(API + `contracts/contract_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setContract_number_method_disable(response.data.details);
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update CompanySettings",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/profile"),
              },
            ],
          });
        }
      })
  };

  const asset_number_method = async () => {
    await axios
      .get(API + `contracts/asser_number_series/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setAssetType(response.data.assettype.split(", "));
          setAssetSettingType(response.data.assettype);
        } else {
          return false;
        }
      })
  };

  const handelStart_Date = (value) => {
    setStart_date(value);
    reset({
      startdate: value,
    });
  };

  useEffect(() => {
    contract_number_method();
    asset_number_method();
    loadInitialOptions();
    reset({
      startdate: start_date,
    });
  }, []);

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    })
  };

  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", {
      headers: authHeader(),
    });
    const getcon = await res.json();
    setPackage(getcon);
  };
  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setInstallCountryid(response.data.country)
      setCountryid(response.data.country)
      setVendorCountryid(response.data.country)
      setCompany(response.data);
    })
  };
  useEffect(() => {
    packagedata();
    company();
  }, []);
  const free = pacakge.filter((value) => value.name === companydata.plan);

  useEffect(() => {
    getExtrafiled();
    getEndDate();
    setPaymentStart_date(start_date);
    setNo_of_payments(contract_term);
    reset({
      paymentstartdate: start_date,
      nopayyments: contract_term,
      startdate: start_date,
    });
  }, [start_date, contract_term, end_date, paymentrule]);

  useEffect(() => {
    if (frequency === "Monthly") {
      setenddate(contract_term / 1);
      setNo_of_payments(contract_term / 1);
    }
    if (frequency === "Quarterly") {
      setenddate(contract_term / 3);
      setNo_of_payments(contract_term / 3);
    }
    if (frequency === "Semi-annual") {
      setenddate(contract_term / 6);
      setNo_of_payments(contract_term / 6);
    }
    if (frequency === "Annual") {
      setenddate(contract_term / 12);
      setNo_of_payments(contract_term / 12);
    }
  }, [no_of_payments, paymentrule, frequency, paymentstart_date]);
  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...filedcontract];
    rowsInput[index][name] = value;
    setFiledContract(rowsInput);
  };

  const navigate = useNavigate();

  const handelContract_term = (value) => {
    setContract_term(value);
  };

  const getEndDate = () => {
    if (start_date === "") {
      return false;
    }
    var dt = new Date(start_date);
    var term = parseInt(contract_term);
    if (contract_term !== "" && !isNaN(dt)) {
      dt.setMonth(dt.getMonth() + term);
      dt.setDate(dt.getDate() - 1);
      setEnd_date(Helper.Dateview(dt));
    }
  };

  const getaddress = async () => {
    if (selectedValue !== null) {
      const resst = await fetch(
        API +
        "parties/manage-address/" +
        selectedValue +
        "/?address_type=bill_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setAddress(await getst.data);
      setAdddressId(await getst.data[0].id);
      reset({
        billto: await getst.data[0].id,
      });
    }
  };

  const loadOptionBillAdd = async (inputValue, callback) => {
    const filteredOptions = address.filter((address) =>
      `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    ).map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
    }));

    setFilterBill(filteredOptions)
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
    }));
    setFilterBill(options)
  }, [address])

  const handleBillAddressChange = (selectedOption) => {
    if (selectedOption) {
      setAdddressId(selectedOption.value);
      reset({ billto: selectedOption.value });
    } else {
      setAdddressId(null)
      setSelectedBill(null)
      reset({ billto: null });
    }
    trigger("billto");
  };

    useEffect(() => {
      if (filterBill.find((val) => val.value === address_id)) {
        trigger("billto");
      }
    }, [address_id, trigger]);

  const handelvender = async () => {
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
      headers: authHeader(),
    });
    const gtst = await rsst.json();
    setVendorName(await gtst);
  };
  useEffect(() => {
    getaddress();
    getinstalladdress();
    handelvender();
  }, [selectedValue]);

  const handlepaymentscreen = (id) => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AddPaymentScheduleService.addPaymentSchedule(
        id,
        no_of_payments,
        payment_type,
        amount,
        frequency,
        Helper.DatePicker(start_date),
        Helper.DatePicker(Paymentend_date),
        rowsData
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
        }
      })
    }
  };

  // const generateRandomSerialNumber = (length = 5) => {
  //   const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  //   let serialNumber = '';
  //   for (let i = 0; i < length; i++) {
  //     const randomIndex = Math.floor(Math.random() * chars.length);
  //     serialNumber += chars[randomIndex];
  //   }
  //   return serialNumber;
  // };

  const handleCreateItem = (asset_id, financed_amt) => {
    let itemid = ''
    let description = asset_desc
    let itemname = ''
    let serial_number = ''
    let life_in_months = null
    let netbookvalue = vehicle_cost
    let originalcost = financed_amt
    let item_type = ""
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    let status = 'In Transit'
    AddItemmasterService.addItemmaster(
      itemid,
      itemname,
      description,
      serial_number,
      year,
      manufacturer,
      model,
      make,
      Date,
      life_in_months,
      netbookvalue,
      originalcost,
      status,
      asset_id,
      item_type
    ).then(
      (response) => {
        if (response.data.success === 1) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setLoading(false)
        }
        else {
          setLoading(false)
          setDisable(false)
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        }
      },
    )
  }

    const handleExitingInventory = () => {
      let item_type = ""
      if (asset_type.length === 1) {
        item_type = asset_typesetting;
      } else {
        item_type = asset_typeselection;
      }
      if (item_type === '') {
        confirmAlert({
          title: "",
          message: "Please select asset type before select inventory.",
          buttons: [
            {
              label: "OK",
              onClick: () => {
                setState3({ isPaneOpen: false });
                setState6({ isPaneOpen: false });
              },
            },
          ],
        });
      } else {
        setState3({ isPaneOpen: false });
        setState6({ isPaneOpen: true });
      }
    }

  const handleRegisterasset = (id) => {

    const total_cost = parseInt(vehicle_cost);
    const financed_amt = parseInt(total_cost);
    const dealer_pay = parseInt(total_cost);

    form.current.validateAll();
    let DelecieryDate = null;
    let Inservicedate = null;
    let assettype = "";
    if (checkBtn.current.context._errors.length === 0) {
      if (in_service_date) {
        Inservicedate = Helper.DatePicker(in_service_date);
      } else {
        setIn_service_date(in_service_date);
      }
      if (delivery_date) {
        DelecieryDate = Helper.DatePicker(delivery_date);
      } else {
        setDelivery_date(delivery_date);
      }
      if (vehicle_cost <= 0) {
        toast.error("Please enter valid Vehical Cost ", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        return false;
      }
      if (asset_type.length === 1) {
        assettype = asset_typesetting;
      } else {
        assettype = asset_typeselection;
      }
      AddAssetService.addAsset(
        id,
        asset_number,
        formData.asset_desc ? formData.asset_desc : asset_desc,
        formData.license_number ? formData.license_number : license_number,
        financed_amt,
        formData.year ? formData.year : year,
        formData.vin_number ? formData.vin_number : vin_number,
        formData.license_state ? formData.license_state : license_state,
        dealer_pay,
        formData.manufacturer ? formData.manufacturer : manufacturer,
        formData.make ? formData.make : make,
        formData.model ? formData.model : model,
        user_purpose,
        formData.residulevalue ? formData.residulevalue : residal_value,
        reg_address1,
        vendername1,
        DelecieryDate,
        formData.in_service_date ? Helper.DatePicker(formData.in_service_date) : Inservicedate,
        formData.mileage ? formData.mileage : milage,
        vehicle_cost,
        vehicle_cost_payto,
        tax_amount,
        tax_amount_payto,
        trade_in,
        trade_in_payto,
        reg_cost,
        reg_cost_payto,
        total_cost,
        down_payment,
        down_payment_payto,
        assettype,
        '',
        item_master_id !== '' ? item_master_id : ''
      ).then((response) => {
        if (response.data.success) {
          if (asset_desc !== null) {
            if (item_master_id === '') {
              // Inventory records should only be created during contract activation, not during asset entry. Disabled per request.
              // let asset_id = response.data.id
              // handleCreateItem(asset_id, financed_amt)
            }
          }
          if (contract_term === "Loan") {
            handlefinanced(id);
          } else {
            handleiir(id);
            handlefinanced(id);
          }
        } else {
        }
      })
    }
  };

  const handlefinanced = (id) => {
    let url = API + "contracts/financedamount/" + id + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data))
  };

  const handleiir = (id) => {
    let url = API + "contracts/contractiir/?";
    url += "id=" + id;
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data))
  };

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisablebutton(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddContractService.addContract(
        contract_number,
        selectedValue,
        Helper.DatePicker(start_date),
        contract_term,
        address_id,
        contract_type,
        Helper.DatePicker(end_date),
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        paymentrule,
        filedcontract,
        Helper.DatePicker(paymentstart_date),
        amount,
        frequency,
        payment_type
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setContractID(response.data.contractID);
          setTimeout(() => {
            setDisablebutton(false);
            navigate("/editrentalcontract", {
              state: response.data.contractID,
            });
            handlefinanced(response.data.contractID);
            handleiir(response.data.contractID);
          }, 2000);
          setTimeout(() => {
            handleRegisterasset(response.data.contractID);
            handlepaymentscreen(response.data.contractID);
          }, 1000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setLoading(false);
          setDisablebutton(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      })
    }
  };

  const handelClick = () => {
    navigate("/contract");
  };

  const checkBtn3 = useRef();
  const [installaddress_line_1, setInstallAddress_line_1] = useState("");
  const [installaddress_line_2, setInstallAddress_line_2] = useState("");
  const [installcity, setInstallCity] = useState("");
  const [installzip_code, setInstallZip_code] = useState("");
  const [installcountry, setInstallCountry] = useState("");
  const [installbill_to, setInstallBill_to] = useState("Yes");
  const [installship_to, setInstallShip_to] = useState("No");
  const [installinstall_to, setInstallInstall_to] = useState("Yes");

  const [stateaddressId, setStateAddressId] = useState("")
  const [venderstateaddressId, setVenderStateAddressId] = useState("")
  const [install_stateaddressId, setInstall_StateAddressId] = useState("")

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [filteredVendor, setFilterVendor] = useState([])

  const handleAddressforInstall = () => {
    form3.current.validateAll();
    if (checkBtn3.current.context._errors.length === 0) {
      if (selectedValue === null) {
        confirmAlert({
          title: "",
          message: "Please select customer",
          buttons: [
            {
              label: "OK",
            },
          ],
        });
      } else {
        AddPartyAddressService.addPartyAddress(
          selectedValue,
          installaddress_line_1,
          installaddress_line_2,
          installcity,
          installstateaddress,
          installzip_code,
          installcountry,
          installbill_to,
          installship_to,
          installinstall_to
        ).then((response) => {
          if (response.data.success) {
            setSuccessful(true);

            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            reset({
              address_id: response.data.addressId,
            });
            setReg_address1(response.data.addressId);
            setTimeout(() => {
              getinstalladdress(response.data.addressId);
              setState2({ isPaneOpen: false });
            }, 1000);
            setInstallAddress_line_1("");
            setInstallAddress_line_2("");
            setInstallCity("");
            setInstallStateAddress("");
            setInstallZip_code("");
            setInstallCountry("");
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
      }
    }
  };

  const getcountry = async () => {
    const res = await fetch(API + "helper/ajax/load-countries/");
    const getcon = await res.json();
    setCountry_name(await getcon);
    setVendor_Country_name(await getcon);
    setInstall_Country_name(await getcon)
  }

  const getstate = async () => {
    if (countryid) {
      const resst = await fetch(API + "helper/ajax/load-states/" + countryid + "/");
      const getst = await resst.json();
      setState(await getst);
    }
    if (installcountryid) {
      const resst = await fetch(API + "helper/ajax/load-states/" + installcountryid + "/");
      const getst = await resst.json();
      setInstall_State(await getst);
    }
    if (vendorcountryid) {
      const resst = await fetch(API + "helper/ajax/load-states/" + vendorcountryid + "/");
      const getst = await resst.json();
      setVendor_State(await getst);
    }
  };

  const handlecountry = (event) => {
    const getcoutryId = event.target.value;
    setCountryid(getcoutryId)
    const countryName = country_name.filter((val) => val.id === parseInt(getcoutryId))
    const getcountryName = countryName[0]?.name || null;
    setCountry(getcountryName);
    reset({
      country_name: getcountryName
    })
  }

  const handlecountryVendor = (event) => {
    const getcoutryId = event.target.value;
    setVendorCountryid(getcoutryId)
    const countryName = country_name.filter((val) => val.id === parseInt(getcoutryId))
    const getcountryName = countryName[0]?.name || null;
    setVendorCountry(getcountryName);
    reset({
      vendor_country_name: getcountryName
    })
  }
  const handlecountryInstall = (event) => {
    const getcoutryId = event.target.value;
    setInstallCountryid(getcoutryId)
    const countryName = install_country_name.filter((val) => val.id === parseInt(getcoutryId))
    const getcountryName = countryName[0]?.name || null;
    setInstallCountry(getcountryName);
    reset({
      install_country_name: getcountryName
    })
  }

  const handlestate = (event) => {
    const getstateId = event.target.value;
    setStateAddressId(getstateId)

    const stateName = state_name.filter((val) => val.id === parseInt(getstateId))
    const getstateName = stateName[0]?.name || null
    setStateAddress(getstateName)
    reset({
      state: getstateName
    })
  }

  const handlestateVender = (event) => {
    const getstateId = event.target.value;
    setVenderStateAddressId(getstateId)

    const stateName = vendor_state_name.filter((val) => val.id === parseInt(getstateId))
    const getstateName = stateName[0]?.name || null
    setVendorStateAddress(getstateName)
    reset({
      vendorstateaddress: getstateName
    })
  }
  const handlestateInstall = (event) => {
    const getstateId = event.target.value;
    setInstall_StateAddressId(getstateId)

    const stateName = install_state_name.filter((val) => val.id === parseInt(getstateId))
    const getstateName = stateName[0]?.name || null
    setInstallStateAddress(getstateName)
    reset({
      install_state_name: getstateName
    })
  }

  useEffect(() => {
    if (countryid !== null && countryid !== undefined) {
      getstate();
    }
    if (installcountryid !== null && installcountryid !== undefined) {
      getstate();
    }
    if (vendorcountryid !== null && vendorcountryid !== undefined) {
      getstate();
    }
  }, [countryid, installcountryid, vendorcountryid]);

  useEffect(() => {
    getcountry()
  }, [])

  useEffect(() => {
    if (countryid) {
      const countryName = country_name.filter((val) => val.id === parseInt(countryid));
      const getcountryName = countryName[0]?.name || null;
      setCountry(getcountryName);
      reset({
        country_name: getcountryName
      });
    }
  }, [countryid, country_name]);

  useEffect(() => {
    if (installcountryid) {
      const countryName = install_country_name.filter((val) => val.id === parseInt(installcountryid));
      const getcountryName = countryName[0]?.name || null;
      setInstallCountry(getcountryName);
      reset({
        install_country_name: getcountryName
      });
    }
  }, [installcountryid, install_country_name])

  useEffect(() => {
    if (vendorcountryid) {
      const countryName = vendor_country_name.filter((val) => val.id === parseInt(vendorcountryid));
      const getcountryName = countryName[0]?.name || null;
      setVendorCountry(getcountryName);
      reset({
        vendorcountry: getcountryName
      });
    }
  }, [vendorcountryid, vendor_country_name])

  const loadOptionInstallAdd = async (inputValue, callback) => {
    const filteredOptions = reg_address.filter((address) =>
      `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    ).map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
    }));

    setFilteredOptions(filteredOptions)
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = reg_address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
    }));
    setFilteredOptions(options)
  }, [customer_name, reg_address, reg_address1])

  const handleAddressChange = (selectedOption) => {
    if (selectedOption) {
      setReg_address1(selectedOption.value)
      setSelectedAddress(selectedOption.value)
      reset({ address_id: selectedOption.value });
    } else {
      setReg_address1(null)
      setSelectedAddress(null)
      reset({ address_id: null });

    }
    trigger("addressid");

  };

  useEffect(() => {
    if (filteredOptions.find((val) => val.value === reg_address1)) {
      trigger("addressid");
    }
  }, [reg_address1, trigger]);
  
  const loadOptionVendorName = async (inputValue, callback) => {
    const filteredOptions = vendor_name.filter((val) =>
      val.customer_name
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    ).map((values) => ({
      value: values.id,
      label: values.customer_name
    }));

    setFilterVendor(filteredOptions)
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = vendor_name.map((val) => ({
      value: val.id,
      label: val.customer_name
    }));
    setFilterVendor(options)
  }, [vendor_name])

  const handleVendorChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedVendor(selectedOption.value);
      setVendorName1(selectedOption.value)
      reset({
        vendorname1: selectedOption.value
      })
    } else {
      setSelectedVendor(null);
      setVendorName1(null)
    }
  };
  const handlePartyAsset = () => {
    setFormData({
      asset_desc: asset_desc,
      asset_number: asset_number,
      make: make,
      manufacturer: manufacturer,
      mileage: milage,
      model: model,
      residulevalue: residal_value,
      vin_number: vin_number,
      year: year,
      in_service_date: in_service_date,
      license_number: license_number,
      license_state: license_state
    });
    if (form5.current) {
      // setAsset_desc('')
      // setVin_number('')
      // setYear('')
      // setManufacturer('')
      // setMake('')
      // setModel('')
      // setResidal_value(null)
      // setIn_service_date('')
      // setMilage(null)
      reset5({
        asset_desc: asset_desc,
        year: year,
        make: make,
        model: model,
        manufacturer: manufacturer
      })
      reset({
        vehiclecost: vehicle_cost
      })
      setTimeout(() => {
        setState3({ isPaneOpen: false });
        setState6({ isPaneOpen: false });
      }, 2000);
    }
  };

  const handlevin = (e) => {
    if (vin_number === "") {
      return false
    }
    else {
      let url = `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${e.target.value}?format=json`;
      axios.get(url, { headers: authHeader() })
        .then((response) => {

          // setVinDecode(response.data)
          setMake(response.data.Results[0].Make)
          setModel(response.data.Results[0].Model)
          setManufacturer(response.data.Results[0].Manufacturer)
          setYear(response.data.Results[0].ModelYear)
        }
        )
    }
  }

  useEffect(() => {
    setIsEquipment(asset_typeselection === 'Equipment');
  }, [asset_typeselection]);

  const addTableRows = () => {
    setTermError("")
    const rowsInput = {
      no_of_payments: "",
      payment_type: 'Rent',
      payment_frequency: frequency,
      start_date: "",
      end_date: "",
      amount: null,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    setTermError("")
    // totalInvoiceAmount();
  };

  const handleTermChange = (index, value) => {
    const termMonths = parseInt(value);
    const updatedRowsData = [...rowsData];
    const currentType = updatedRowsData[index].payment_type;
    let startDate = new Date(start_date)
    setTermError('')
    if (currentType === 'Rent') {
      setTermError('')
      updatedRowsData[index].no_of_payments = value;
      if (frequency === 'Monthly') {
        if (value === '') {
          updatedRowsData[index].start_date = '';
          updatedRowsData[index].end_date = '';
          setTermError('');
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms = updatedRowsData.reduce((acc, row, idx) => {
            return idx === index ? acc : acc + (row.payment_type === 'Rent' ? parseInt(row.no_of_payments || 0) : 0);
          }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError('');

            if (index === 0) {
              startDate = new Date(start_date)
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === 'Rent') {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);

            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          }
        }
      } else if (frequency === 'Quarterly') {
        const totalTerm = contract_term / frequencyMapped.Quarterly
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Rent' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Rent') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Quarterly';
        }
      } else if (frequency === 'Semi-annual') {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Rent' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Rent') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Semi-annual';

        }
      }
      else if (frequency === 'Annual') {
        const totalTerm = contract_term / frequencyMapped.Annual
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Rent' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Rent') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Annual';
        }
      }
      setRowsData(updatedRowsData);
    } else if (currentType === 'Maintenance Fee') {
      let frequencyData;
      setTermError('')
      updatedRowsData[index].no_of_payments = value;
      frequencyData = updatedRowsData[index].payment_frequency;

      if (frequencyData === 'Monthly') {
        if (value === '') {
          updatedRowsData[index].start_date = '';
          updatedRowsData[index].end_date = '';
          setTermError('');
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms = updatedRowsData.reduce((acc, row, idx) => {
            return idx === index ? acc : acc + (row.payment_type === 'Maintenance Fee' ? parseInt(row.no_of_payments || 0) : 0);
          }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError('');

            if (index === 0) {
              startDate = new Date(start_date)
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === 'Maintenance Fee') {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);
            updatedRowsData[index].payment_frequency = 'Monthly';
            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          }
        }
      } else if (frequencyData === 'Quarterly') {
        const totalTerm = contract_term / frequencyMapped.Quarterly
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Maintenance Fee' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Maintenance Fee') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Quarterly';
        }
      } else if (frequencyData === 'Semi-annual') {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Maintenance Fee' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Maintenance Fee') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Semi-annual';

        }
      }
      else if (frequencyData === 'Annual') {
        const totalTerm = contract_term / frequencyMapped.Annual
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return acc + (row.payment_type === 'Maintenance Fee' ? parseInt(row.no_of_payments || 0) : 0);
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError('');

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === 'Maintenance Fee') {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths
          endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1)
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = 'Annual';
        }
      }
      setRowsData(updatedRowsData);
    } else {
      // All other fee types (Security Deposit, Late Fee, Origination Fee, etc.)
      const frequencyData = updatedRowsData[index].payment_frequency || frequency;
      updatedRowsData[index].no_of_payments = value;

      if (value === '') {
        updatedRowsData[index].start_date = '';
        updatedRowsData[index].end_date = '';
        updatedRowsData[index].paymentstart_date = '';
      } else if (!isNaN(termMonths) && termMonths > 0) {
        const frequencyMonths = { Monthly: 1, Quarterly: 3, 'Semi-annual': 6, Annual: 12 };
        const months = (frequencyMonths[frequencyData] || 1) * termMonths;
        const rowStartDate = new Date(start_date);
        const rowEndDate = new Date(rowStartDate);
        rowEndDate.setMonth(rowEndDate.getMonth() + months);
        rowEndDate.setDate(rowEndDate.getDate() - 1);
        updatedRowsData[index].start_date = Helper.DatePicker(rowStartDate);
        updatedRowsData[index].end_date = Helper.DatePicker(rowEndDate);
        updatedRowsData[index].paymentstart_date = Helper.DatePicker(rowStartDate);
      }

      setRowsData(updatedRowsData);
    }
  };

  const handelChangeAmount = (index, event) => {
    setTermError('')
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].amount = event;

    setRowsData(updatedRowsData);
  };

  const handlePayment = () => {
    const term = rowsData.map((val) => val.no_of_payments);
    const amount = rowsData.map((val) => val.amount);

    setTermError('');

    let contractTerm = null;
    if (frequency === 'Monthly') {
      contractTerm = contract_term / frequencyMapped.Monthly;
    } else if (frequency === 'Quarterly') {
      contractTerm = contract_term / frequencyMapped.Quarterly;
    } else if (frequency === 'Semi-annual') {
      contractTerm = contract_term / frequencyMapped.SemiAnnual;
    } else if (frequency === 'Annual') {
      contractTerm = contract_term / frequencyMapped.Annual;
    }
    const totalPayments = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);
      return row.payment_type === 'Rent' ? sum + (isNaN(payments) ? 0 : payments) : sum;
    }, 0);

    let rowContractTerm = null;
    const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);


      if (row.payment_type === 'Maintenance Fee') {
        if (row.payment_frequency === 'Monthly') {
          rowContractTerm = contract_term / frequencyMapped.Monthly;
        } else if (row.payment_frequency === 'Quarterly') {
          rowContractTerm = contract_term / frequencyMapped.Quarterly;
        } else if (row.payment_frequency === 'Semi-annual') {
          rowContractTerm = contract_term / frequencyMapped.SemiAnnual;
        } else if (row.payment_frequency === 'Annual') {
          rowContractTerm = contract_term / frequencyMapped.Annual;
        }
      }

      return row.payment_type === 'Maintenance Fee' ? sum + (isNaN(payments) ? 0 : payments) : sum;
    }, 0)

    if (term.includes('') || term.includes(0)) {
      setTermError('No of payment is required');
      return;
    }
    if (amount.includes('') || amount.includes(null)) {
      setTermError('Amount is required');
      return;
    }

    const negativeAmount = amount.some(a => parseFloat(a) < 0);
    if (negativeAmount) {
      setTermError('Only positive numbers are allowed');
      return;
    }

    if (totalPayments !== contractTerm) {
      setTermError(`Total number of Rent term ${contractTerm} is required`);
      return;
    }

    if (totalPaymentsMaintentence > rowContractTerm) {
      setTermError(`Total number of Maintenance term ${rowContractTerm} is required`);
      return;
    }

    if (!termError) {
      setTimeout(() => {
        setState5({ isPaneOpen: false });
      }, 1000);
    } else {
      setRowsData([...rowsData]);
    }
  };

  useEffect(() => {
    if (amount !== null && amount > 0 && amount !== undefined && contract_term !== '') {
      let contractTerm = null;
      let startDate;
      let endDate;
      if (frequency === 'Monthly') {
        contractTerm = contract_term / frequencyMapped.Monthly;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + contractTerm);
        endDate.setDate(endDate.getDate() - 1);
      } else if (frequency === 'Quarterly') {
        contractTerm = contract_term / frequencyMapped.Quarterly;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.Quarterly * contractTerm
        endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1)
      } else if (frequency === 'Semi-annual') {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.SemiAnnual * contractTerm
        endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1)
      } else if (frequency === 'Annual') {
        contractTerm = contract_term / frequencyMapped.Annual;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.Annual * contractTerm
        endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1)
      }
      const rowsInput = {
        no_of_payments: contractTerm,
        payment_type: 'Rent',
        start_date: Helper.DatePicker(startDate),
        end_date: Helper.DatePicker(endDate),
        amount: amount,
      };
      setRowsData([rowsInput])
    } else {
      setRowsData([])
    }

  }, [amount, frequency, contract_term, frequencyMapped, start_date])

  const isDisabled = rowsData.length > 1;

  const handlePaymentTypeChange = (index, event) => {
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].payment_frequency = frequency;
    // const restrictedTypes = ['Origination Fee', 'Documentation Fee', 'Maintenance Fee'];
    const restrictedTypes = ['Origination Fee', 'Documentation Fee'];
    if (restrictedTypes.includes(event)) {
      const paymentTypeExists = updatedRowsData.some((row, idx) => row.payment_type === event && idx !== index);

      if (paymentTypeExists) {
        setTermError(`${event} can only have one entry.`);
        return;
      }
    }
    updatedRowsData[index].payment_type = event;

    if (event === 'Origination Fee' || event === 'Documentation Fee') {
      const contractTerm = contract_term / frequencyMapped.Annual;
      let startDate = new Date(start_date);
      let endDate = new Date(startDate);
      // const month = frequencyMapped.Annual * contractTerm;
      if (frequency === 'Monthly') {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = 'Monthly';
      } else if (frequency === 'Quarterly') {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = 'Quarterly';
      } else if (frequency === 'Semi-annual') {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = 'Semi-annual';
      } else if (frequency === 'Annual') {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = 'Annual';
      }
    } else if (event === 'Rent') {
      updatedRowsData[index].payment_frequency = frequency;
    }

    setRowsData(updatedRowsData);
  };

  const handlePaymentFrequencyChange = (index, selectedValue) => {
    let updatedRowsData = [...rowsData];
    updatedRowsData[index].no_of_payments = "";
    let startDate = new Date(start_date);
    let paymentstartDate;
    updatedRowsData[index].payment_frequency = frequency;
    if (paymentrule === 'Advance') {
      paymentstartDate = new Date(start_date)
    } else {
      paymentstartDate = new Date(paymentstart_date)
    }
    if (updatedRowsData[index].payment_type === 'Maintenance Fee') {
      let contractTerm = null;
      if (selectedValue === 'Monthly') {
        contractTerm = contract_term / frequencyMapped.Monthly;
      } else if (selectedValue === 'Quarterly') {
        contractTerm = contract_term / frequencyMapped.Quarterly;
      } else if (selectedValue === 'Semi-annual') {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
      } else if (selectedValue === 'Annual') {
        contractTerm = contract_term / frequencyMapped.Annual;
      }
      updatedRowsData[index].no_of_payments = "";
      updatedRowsData[index].start_date = Helper.DatePicker(startDate);
      updatedRowsData[index].payment_frequency = selectedValue;
      updatedRowsData[index].paymentstart_date = Helper.DatePicker(paymentstartDate);
      updatedRowsData[index].end_date = '';
      const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
        const payments = parseInt(row.no_of_payments, 10);
        return row.payment_type === 'Maintenance Fee' ? sum + (isNaN(payments) ? 0 : payments) : sum;
      }, 0);
      if (totalPaymentsMaintentence > contractTerm) {
        setTermError(`Total number of Maintenance term ${contractTerm} is required`);
        return;
      }
    } else {
      updatedRowsData[index].payment_frequency = frequency;
    }
    setRowsData(updatedRowsData);
  };
  const FeeDefination = () => {
    let url = API + "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes"
    axios.get(url, { headers: authHeader() }).then(
      response => {
        setPaymentType(response.data);
      }
    )
  }
  useEffect(() => {
    FeeDefination()
  }, [])

  const [state6, setState6] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [itemSelect, setItemSelect] = useState('')

  const [valueItem, setValueItem] = useState('')
  const [valueNumber, setValueNumber] = useState()
  const [selectSerial, setSelectSerial] = useState('')

  const [selectModel, setselectModel] = useState('')
  const [valueModel, setValueModel] = useState('')

  const [selectMake, setselectMake] = useState('')
  const [valueMake, setValueMake] = useState('')

  const [selectManu, setselectManu] = useState('')
  const [valueManu, setValueManu] = useState('')

  const [item_master_id, setItem_master_id] = useState('')

  const [inventory_option, setInventory_option] = useState([])
  const loadOptionItem = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `contracts/itemmaster/filter/?itemname=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handelInputChangeItem = (value) => {
    setValueItem(value);
  };

  const handelChangeItem = (value) => {
    setItemSelect(value);
  };

  const loadOptionsserial = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?serialnumber=${inputValue2}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  const handelChangeserial = (value1) => {
    setSelectSerial(value1);
  };
  const handelInputChangeSerial = (value1) => {
    setValueNumber(value1);
  };

  const handelChangemodel = (value1) => {
    setselectModel(value1);
  };

  const handelInputChangeModel = (value1) => {
    setValueModel(value1);
  };

  const handelChangeMake = (value1) => {
    setselectMake(value1);
  };

  const loadOptionsMake = async (inputValue4) => {
    if (inputValue4 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?make=${inputValue4}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChangeMake = (value1) => {
    setValueMake(value1);
  };


  const loadOptionsModel = async (inputValue3) => {
    if (inputValue3 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?model=${inputValue3}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelChangeManu = (value1) => {
    setselectManu(value1);
  };

  const loadOptionsManu = async (inputValue6) => {
    if (inputValue6 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?manufacturer=${inputValue6}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  const handelInputChangeManu = (value1) => {
    setValueManu(value1);
  };

  const handleClear = () => {
    setItemSelect("");
    setSelectSerial("");
    setselectModel("");
    setselectMake("");
    setselectManu("");
    setAsset_desc('')
    setItem_master_id(null)
    setYear('')
    setMake("")
    setModel("")
    setManufacturer("")
    setInventory_option([])
    setVehicle_cost(0)
    reset5({
      asset_desc: '',
      year: '',
      make: '',
      model: '',
      manufacturer: ''
    })
    setState3({ isPaneOpen: false });
    setState6({ isPaneOpen: false });
  };

  const handelSearch = () => {
    let item_type = ""
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    axios.get(`${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ''}&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""}&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""}&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""}`, {
      headers: authHeader()
    }).then((res) => {
      const optionsList = res.data.map(val => val);
      setInventory_option(optionsList);
      setState3({ isPaneOpen: true });
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  useEffect(() => {
    let item_type = ""
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    axios.get(`${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ''}&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""}&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""}&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""}`, {
      headers: authHeader()
    }).then((res) => {
      const optionsList = res.data.map(val => val);
      setInventory_option(optionsList);
      // setState3({ isPaneOpen: true });
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  }, [asset_typeselection, asset_typesetting, state6])

  const handleTagClick = (tag) => {
    setItem_master_id(tag.id);

    setState3({ isPaneOpen: true });
    setState6({ isPaneOpen: false });
  };
  useEffect(() => {
    if (item_master_id) {
      EditItemMasterService.getItemmaster(item_master_id).then(
        (response) => {
          setAsset_desc(response.data.description)
          setYear(response.data.yearofmanufacture)
          setMake(response.data.make)
          setModel(response.data.model)
          setManufacturer(response.data.manufacturer)
          setVehicle_cost(response.data.netbookvalue)

          setLoading(false)
        }
      )
    }
  }, [item_master_id])

  useEffect(() => {
    reset5({
      asset_desc: asset_desc
    })
  }, [asset_desc]);

  return (
    <>
      <div className="content container-fluid">
        <ToastContainer />
        <SlidingPane
          className="some-custom-class sidepanebar"
          isOpen={state4.isPaneOpen}
          title="Add Vendor"
          subtitle=""
          onRequestClose={() => {
            setState4({ isPaneOpen: false });
          }}
        >
          <Form
            role="form text-left"
            onSubmit={handleSubmit4(handlepartyvendor)}
            ref={form4}
            key={4}
            action="."
            method="POST"
            id="addReceiptForm"
          >
            {
              <>
                <div className="row">
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Party Type")}{" "}
                      <Tooltip content={t("PartyType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="form-group row">
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "3.0em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={party_typevendor === "Vendor" ? true : false}
                          value="Vendor"
                          type="radio"
                          name="vendor"
                          id="flexRadioDefault2"
                          onChange={(e) => setParty_typeVendor(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          Vendor
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="col-form-label required">
                    {t("Entity Type")}{" "}
                    <Tooltip content={t("EntityType_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </label>
                  <div className="form-group row">
                    <div
                      className="form-check"
                      style={{ width: "25%", paddingLeft: "2.73em" }}
                    >
                      <input
                        className="form-check-input"
                        checked={
                          customer_typevendor === "Person" ? true : false
                        }
                        value="Person"
                        type="radio"
                        name="person"
                        id="id_customer_type"
                        {...register4("customer_type", {
                          onChange: (e) => {
                            handleshowhidevendor(e);
                          },
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Person
                      </label>
                    </div>
                    <div
                      className="form-check"
                      style={{ width: "25%", paddingLeft: "4.73em" }}
                    >
                      <input
                        className="form-check-input"
                        checked={
                          customer_typevendor === "Organization" ? true : false
                        }
                        value="Organization"
                        type="radio"
                        name="organization"
                        id="id_customer_type"
                        {...register4("customer_type", {
                          onChange: (e) => {
                            handleshowhidevendor(e);
                          },
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Organization
                      </label>
                    </div>
                  </div>

                  <div className="invalid-feedback">
                    {errors4.customer_type?.type === "required" &&
                      "Entity Type  is required"}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label className="col-form-label required">
                      {t("Party Name")}{" "}
                      <Tooltip content={t("PartyName_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("Party Name")}
                      className="form-control"
                      type="text"
                      value={customer_namevendor}
                      name="customer_name"
                      maxLength="200"
                      id="id_customer_name"
                      {...register4("customer_name", {
                        onChange: (e) => {
                          setCustomer_nameVendor(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors4.customer_name?.type === "required" &&
                        "Party Name  is required"}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Address Line 1")}{" "}
                        <Tooltip content={t("Address_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 1")}
                        className="form-control"
                        type="text"
                        name="address_line_1"
                        maxLength="200"
                        id="id_address_line_1"
                        value={vendoraddress_line_1}
                        {...register4("address_line_1", {
                          onChange: (e) => {
                            setVendorAddress_line_1(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors4.address_line_1?.type === "required" &&
                          "Address is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Address Line 2")}{" "}
                        <Tooltip content={t("Address2_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 2")}
                        className="form-control"
                        type="text"
                        onChange={(e) =>
                          setVendorAddress_line_2(e.target.value)
                        }
                        name="address_line_2"
                        maxLength="200"
                        id="id_address_line_2"
                        value={vendoraddress_line_2}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Country")}{" "}
                        <Tooltip content={t("Country_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        type="text"
                        className="form-control"
                        value={vendorcountryid}
                        name="country"
                        // onChange={(e) => handlecountry(e)}
                        {...register4("country", { onChange: (e) => { handlecountryVendor(e) }, required: true })}
                      >
                        <option value="">---{t("Select Country")}---</option>
                        {
                          vendor_country_name.map((country, i) =>
                          (
                            <option key={i} value={country.id} >{country.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors4.country?.type === "required" &&
                          "Country is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("State")}{" "}
                        <Tooltip content={t("State_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        value={venderstateaddressId}
                        className="form-control"
                        name="state"
                        {...register4("state", { onChange: (e) => { handlestateVender(e) }, required: true })}
                      >
                        <option value="">---{t("Select State")}---</option>
                        {
                          vendor_state_name.map((resst, i) => (
                            <option key={i} value={resst.id} >{resst.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors4.state?.type === "required" &&
                          "State is required"}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("City")}{" "}
                        <Tooltip content={t("City_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("City")}
                        className="form-control"
                        type="text"
                        name="city"
                        maxLength="100"
                        id="id_city"
                        value={vendorcity}
                        {...register4("city", {
                          onChange: (e) => {
                            setVendorCity(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors4.city?.type === "required" &&
                          "City is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Zip Code")}{" "}
                        <Tooltip content={t("ZipCode_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Zip Code")}
                        className="form-control"
                        type="text"
                        name="zip_code"
                        maxLength="30"
                        id="id_zip_code"
                        value={vendorzip_code}
                        {...register4("zip_code", {
                          onChange: (e) => {
                            setVendorZip_code(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors4.zip_code?.type === "required" &&
                          "Zip Code is required"}
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="border-0 btn btn-primary btn-gradient-primary btn-md"
                >
                  {t("Save")}
                </button>
                &nbsp;&nbsp;
              </>
            }
            <CheckButton style={{ display: "none" }} ref={checkBtn4} />
          </Form>
        </SlidingPane>
        <SlidingPane
          className="some-custom-class sidepanebar"
          isOpen={state2.isPaneOpen}
          title="Add Address"
          subtitle=""
          onRequestClose={() => {
            setState2({ isPaneOpen: false });
          }}
        >
          <Form
            role="form text-left"
            onSubmit={handleSubmit3(handleAddressforInstall)}
            ref={form3}
            key={3}
            action="."
            method="POST"
            id="addReceiptForm"
          >
            {
              <>
                <div className="row">
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Address Line 1")}{" "}
                        <Tooltip content={t("Address_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 1")}
                        className="form-control"
                        type="text"
                        name="installaddress_line_1"
                        maxLength="200"
                        id="id_address_line_1"
                        value={installaddress_line_1}
                        {...register3("installaddress_line_1", {
                          onChange: (e) => {
                            setInstallAddress_line_1(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors3.installaddress_line_1?.type === "required" &&
                          "Address is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Address Line 2")}{" "}
                        <Tooltip content={t("Address2_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 2")}
                        className="form-control"
                        type="text"
                        onChange={(e) =>
                          setInstallAddress_line_2(e.target.value)
                        }
                        name="installaddress_line_2"
                        maxLength="200"
                        id="id_address_line_2"
                        value={installaddress_line_2}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Country")}{" "}
                        <Tooltip content={t("Country_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        type="text"
                        className="form-control"
                        value={installcountryid}
                        name="installcountry"
                        {...register3("installcountry", { onChange: (e) => { handlecountryInstall(e) }, required: true })}
                      >
                        <option value="">---{t("Select Country")}---</option>
                        {
                          country_name.map((country, i) =>
                          (
                            <option key={i} value={country.id} >{country.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors3.installcountry?.type === "required" &&
                          "Country is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("State")}{" "}
                        <Tooltip content={t("State_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        value={install_stateaddressId}
                        className="form-control"
                        name="installstate"
                        {...register3("installstate", { onChange: (e) => { handlestateInstall(e) }, required: true })}
                      >
                        <option value="">---{t("Select State")}---</option>
                        {
                          install_state_name.map((resst, i) => (
                            <option key={i} value={resst.id} >{resst.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors3.installstate?.type === "required" &&
                          "State is required"}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("City")}{" "}
                        <Tooltip content={t("City_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("City")}
                        className="form-control"
                        type="text"
                        name="installcity"
                        maxLength="100"
                        id="id_city"
                        value={installcity}
                        {...register3("installcity", {
                          onChange: (e) => {
                            setInstallCity(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors3.installcity?.type === "required" &&
                          "City is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Zip Code")}{" "}
                        <Tooltip content={t("ZipCode_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Zip Code")}
                        className="form-control"
                        type="text"
                        name="installzip_code"
                        maxLength="30"
                        id="id_zip_code"
                        value={installzip_code}
                        {...register3("installzip_code", {
                          onChange: (e) => {
                            setInstallZip_code(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors3.installzip_code?.type === "required" &&
                          "Zip Code is required"}
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="border-0 btn btn-primary btn-gradient-primary btn-md"
                >
                  {t("Save")}
                </button>
                &nbsp;&nbsp;
              </>
            }
            <CheckButton style={{ display: "none" }} ref={checkBtn3} />
          </Form>
        </SlidingPane>
        <SlidingPane
          className="some-custom-class sidepanebar"
          isOpen={state1.isPaneOpen}
          title="Add Customer"
          subtitle=""
          onRequestClose={() => {
            setState1({ isPaneOpen: false });
          }}
        >
          <Form
            role="form text-left"
            onSubmit={handleSubmit2(handlepartydefault)}
            ref={form2}
            key={2}
            action="."
            method="POST"
            id="addReceiptForm"
          >
            {
              <>
                <div className="row">
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Party Type")}{" "}
                      <Tooltip content={t("PartyType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="form-group row">
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "3.0em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={party_type === "Customer" ? true : false}
                          value="Customer"
                          type="radio"
                          name="vendor"
                          id="flexRadioDefault2"
                          onChange={(e) => setParty_type(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          Customer
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="col-form-label required">
                    {t("Entity Type")}{" "}
                    <Tooltip content={t("EntityType_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </label>
                  <div className="form-group row">
                    <div
                      className="form-check"
                      style={{ width: "25%", paddingLeft: "2.73em" }}
                    >
                      <input
                        className="form-check-input"
                        checked={customer_type === "Person" ? true : false}
                        value="Person"
                        type="radio"
                        name="person"
                        id="id_customer_type"
                        {...register2("customer_type", {
                          onChange: (e) => {
                            handleshowhide(e);
                          },
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Person
                      </label>
                    </div>
                    <div
                      className="form-check"
                      style={{ width: "25%", paddingLeft: "4.73em" }}
                    >
                      <input
                        className="form-check-input"
                        checked={
                          customer_type === "Organization" ? true : false
                        }
                        value="Organization"
                        type="radio"
                        name="organization"
                        id="id_customer_type"
                        {...register2("customer_type", {
                          onChange: (e) => {
                            handleshowhide(e);
                          },
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Organization
                      </label>
                    </div>
                  </div>
                  <div className="invalid-feedback">
                    {errors2.customer_type?.type === "required" &&
                      "Entity Type  is required"}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label className="col-form-label required">
                      {t("Party Name")}{" "}
                      <Tooltip content={t("PartyName_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("Party Name")}
                      className="form-control"
                      type="text"
                      value={customer_name}
                      name="customer_name"
                      maxLength="200"
                      id="id_customer_name"
                      {...register2("customer_name", {
                        onChange: (e) => {
                          setCustomer_name(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors2.customer_name?.type === "required" &&
                        "Party Name  is required"}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Address Line 1")}{" "}
                        <Tooltip content={t("Address_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 1")}
                        className="form-control"
                        type="text"
                        name="address_line_1"
                        maxLength="200"
                        id="id_address_line_1"
                        value={address_line_1}
                        {...register2("address_line_1", {
                          onChange: (e) => {
                            setAddress_line_1(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors2.address_line_1?.type === "required" &&
                          "Address is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Address Line 2")}{" "}
                        <Tooltip content={t("Address2_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Address Line 2")}
                        className="form-control"
                        type="text"
                        onChange={(e) => setAddress_line_2(e.target.value)}
                        name="address_line_2"
                        maxLength="200"
                        id="id_address_line_2"
                        value={address_line_2}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Country")}{" "}
                        <Tooltip content={t("Country_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        type="text"
                        className="form-control"
                        value={countryid}
                        name="country"
                        id="id_country"
                        {...register2("country", { onChange: (e) => { handlecountry(e) }, required: true })}
                      >
                        <option value="">---{t("Select Country")}---</option>
                        {
                          country_name.map((country, i) =>
                          (
                            <option key={i} value={country.id} >{country.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors2.country?.type === "required" &&
                          "Country is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("State")}{" "}
                        <Tooltip content={t("State_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        value={stateaddressId}
                        className="form-control"
                        name="state"
                        {...register2("state", { onChange: (e) => { handlestate(e) }, required: true })}
                      >
                        <option value="">---{t("Select State")}---</option>
                        {
                          state_name.map((resst, i) => (
                            <option key={i} value={resst.id} >{resst.name}</option>
                          ))
                        }
                      </select>
                      <div className="invalid-feedback">
                        {errors2.state?.type === "required" &&
                          "State is required"}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("City")}{" "}
                        <Tooltip content={t("City_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("City")}
                        className="form-control"
                        type="text"
                        name="city"
                        maxLength="100"
                        id="id_city"
                        value={city}
                        {...register2("city", {
                          onChange: (e) => {
                            setCity(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors2.city?.type === "required" &&
                          "City is required"}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Zip Code")}{" "}
                        <Tooltip content={t("ZipCode_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Zip Code")}
                        className="form-control"
                        type="text"
                        name="zip_code"
                        maxLength="30"
                        id="id_zip_code"
                        value={zip_code}
                        {...register2("zip_code", {
                          onChange: (e) => {
                            setZip_code(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors2.zip_code?.type === "required" &&
                          "Zip Code is required"}
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="border-0 btn btn-primary btn-gradient-primary btn-md"
                >
                  {t("Save")}
                </button>
                &nbsp;&nbsp;
              </>
            }
            <CheckButton style={{ display: "none" }} ref={checkBtn2} />
          </Form>
        </SlidingPane>
        <SlidingPane
          className="some-custom-class sidepanebar"
          isOpen={state3.isPaneOpen}
          title="Add Asset"
          subtitle=""
          onRequestClose={() => {
            setState3({ isPaneOpen: false });
          }}
        >
          {isEquipment ?
            <Form
              role='form text-left'
              onSubmit={handleSubmit5(handlePartyAsset)}
              ref={form5}
              key={5}
              action="."
              method="POST"
              id="addAssetForm"
            >
              {
                <>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Asset Number")}{" "}
                        <Tooltip content={t("Assetnumber_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="form-control"
                          type="text"
                          name="asset_number"
                          maxLength="200"
                          disabled
                          value={asset_number}
                          {...register5("asset_number", {
                            onChange: (e) => {
                              setAsset_number(e.target.value);
                            },
                          })}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        {/* <label className="col-form-label">
                          {t("Asset Description")}{" "}
                          <Tooltip content={t("assetdesc_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label> */}
                        <div className="col-lg-12 d-flex align-items-center">
                          {/* <div className="flex-grow-1">
                            <input
                              placeholder={t("Asset Description")}
                              className="form-control"
                              type="text"
                              name="asset_desc"
                              maxLength="200"
                              id="asset_desc"
                              value={asset_desc}
                              {...register5("asset_desc", {
                                onChange: (e) => {
                                  setAsset_desc(e.target.value);
                                },
                                required: true,
                              })}
                            />
                             <div className="invalid-feedback">
                            {errors5.asset_desc?.type === "required" &&
                              "Asset description is required"}
                          </div>
                          </div>
                          <div
                            onClick={(e) => {
                              setState3({ isPaneOpen: false });
                              setState6({ isPaneOpen: true });
                            }}
                            style={{
                              color: "#b4b7c5",
                              paddingLeft: "10px",
                              cursor: "pointer",

                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL + "/static/images/ic-search.svg"
                              }
                              alt="Filter Icon"
                            />
                          </div> */}
                          {/* <div className="invalid-feedback">
             {errors4.asset_desc?.type === "required" &&
               "Asset Desc is required"}
           </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      {/* <div className="col-md-6">
                        <label className="col-form-label">
                          {t("License No")}{" "}
                          <Tooltip content={t("vinnumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("License No")}
                          className="form-control"
                          type="text"
                          name="license_number"
                          maxLength="200"
                          id="id_license_number"
                          value={license_number}
                          onChange={(e) => setLicense_number(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("License State")}{" "}
                          <Tooltip content={t("year_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("License State")}
                          className="form-control"
                          type="text"
                          name="license_state"
                          id="id_license_state"
                          value={license_state}
                          {...register5("license_state", {
                            onChange: (e) => {
                              setLicense_state(e.target.value);
                            },
                          })}
                        />
                      </div> */}
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Make")}{" "}
                          <Tooltip content={t("Make_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Make")}
                          className="form-control"
                          type="text"
                          name="make"
                          maxLength="30"
                          id="id_make"
                          value={make}
                          {...register5("make", {
                            onChange: (e) => {
                              setMake(e.target.value);
                            },
                          })}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Model")}{" "}
                          <Tooltip content={t("Model_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Model")}
                          className="form-control"
                          type="text"
                          name="model"
                          maxLength="100"
                          id="id_model"
                          value={model}
                          {...register5("model", {
                            onChange: (e) => {
                              setModel(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label className="col-form-label">
                          {t("Manufacturer")}{" "}
                          <Tooltip content={t("Manufacturer_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Manufacturer")}
                          className="form-control"
                          type="text"
                          name="manufacturer"
                          // maxLength="200"
                          // id="manufacturer"
                          value={manufacturer}
                          onChange={(e) => setManufacturer(e.target.value)}
                        // {...register5("manufacturer", {
                        //   onChange: (e) => {
                        //     setManufacturer(e.target.value);
                        //   },
                        // })}
                        />
                        {/* <div className="invalid-feedback">
             {errors4.year?.type === "required" &&
               "Year is required"}
           </div> */}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Residual Value")}{" "}
                          <Tooltip content={t("Residualvalue_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Residual Value")}
                          className="form-control"
                          type="text"
                          name="residulevalue"
                          maxLength="30"
                          id="id_residual_Value"
                          value={residal_value}
                          {...register5("residulevalue", {
                            onChange: (e) => {
                              setResidal_value(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("In Service Date")}{" "}
                          <Tooltip content={t("in_service_date_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <DatePicker
                          className="form-control datepick"
                          selected={in_service_date}
                          onChange={(e) => setIn_service_date(e)}
                          placeholderText={"mm/dd/yyyy"}
                          showYearDropdown // year show and scrolldown alos
                          scrollableYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="border-0 btn btn-primary btn-gradient-primary btn-md"
                  >
                    {t("Save")}
                  </button>
                  &nbsp;&nbsp;
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn5} />

            </Form>
            :
            <Form
              role='form text-left'
              onSubmit={handleSubmit5(handlePartyAsset)}
              ref={form5}
              key={5}
              action="."
              method="POST"
              id="addAssetForm"
            >
              {
                <>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Asset Number")}{" "}
                        <Tooltip content={t("Assetnumber_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="form-control"
                          type="text"
                          name="asset_number"
                          maxLength="200"
                          disabled
                          value={asset_number}
                          {...register5("asset_number", {
                            onChange: (e) => {
                              setAsset_number(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        {/* <label className="col-form-label required">
                          {t("Asset Description")}{" "}
                          <Tooltip content={t("assetdesc_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label> */}
                        <div className="col-lg-12 d-flex align-items-center">
                          {/* <div className="flex-grow-1">
                            <input
                              placeholder={t("Asset Description")}
                              className="form-control"
                              type="text"
                              name="asset_desc"
                              maxLength="200"
                              id="asset_desc"
                              value={asset_desc}
                              {...register5("asset_desc", {
                                onChange: (e) => {
                                  setAsset_desc(e.target.value);
                                },
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                            {errors5.asset_desc?.type === "required" &&
                              "Asset description is required"}
                          </div>
                          </div> */}
                          {/* <div
                            onClick={(e) => {
                              setState3({ isPaneOpen: false });
                              setState6({ isPaneOpen: true });
                            }}
                            style={{
                              color: "#b4b7c5",
                              paddingLeft: "10px",
                              cursor: "pointer",

                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL + "/static/images/ic-search.svg"
                              }
                              alt="Filter Icon"
                            />
                          </div> */}
                        </div>
                        {/* <div className="invalid-feedback">
                        {errors4.asset_desc?.type === "required" &&
                          "Asset Desc is required"}
                      </div> */}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("VIN Number")}{" "}
                          <Tooltip content={t("vinnumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("VIN Number")}
                          className="form-control"
                          type="text"
                          name="vin_number"
                          onBlur={handlevin}
                          maxLength="200"
                          id="id_vin_number"
                          value={vin_number}
                          onChange={(e) => setVin_number(e.target.value)}
                        // {...register5("vin_number", {
                        //   onBlur: handlevin,
                        // })}
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.vin_number?.type === "required" &&
                          "Vin Number is required"}
                      </div> */}
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Year")}{" "}
                          <Tooltip content={t("year_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Year")}
                          className="form-control"
                          type="text"
                          name="year"
                          maxLength="200"
                          id="id_year"
                          value={year}
                          {...register5("year", {
                            onChange: (e) => {
                              setYear(e.target.value);
                            },
                          })}
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.year?.type === "required" &&
                          "Year is required"}
                      </div> */}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Manufacturer")}{" "}
                          <Tooltip content={t("Manufacturer_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Manufacturer")}
                          className="form-control"
                          type="text"
                          name="manufacturer"
                          // maxLength="200"
                          // id="manufacturer"
                          value={manufacturer}
                          onChange={(e) => setManufacturer(e.target.value)}
                        // {...register5("manufacturer", {
                        //   onChange: (e) => {
                        //     setManufacturer(e.target.value);
                        //   },
                        // })}
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.year?.type === "required" &&
                          "Year is required"}
                      </div> */}
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Make")}{" "}
                          <Tooltip content={t("Make_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Make")}
                          className="form-control"
                          type="text"
                          name="make"
                          maxLength="30"
                          id="id_make"
                          value={make}
                          {...register5("make", {
                            onChange: (e) => {
                              setMake(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.make?.type === "required" &&
                          "Make is required"}
                      </div> */}
                      </div>

                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Model")}{" "}
                          <Tooltip content={t("Model_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Model")}
                          className="form-control"
                          type="text"
                          name="model"
                          maxLength="100"
                          id="id_model"
                          value={model}
                          {...register5("model", {
                            onChange: (e) => {
                              setModel(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Residual Value")}{" "}
                          <Tooltip content={t("Residualvalue_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Residual Value")}
                          className="form-control"
                          type="text"
                          name="residulevalue"
                          maxLength="30"
                          id="id_residual_Value"
                          value={residal_value}
                          {...register5("residulevalue", {
                            onChange: (e) => {
                              setResidal_value(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                      </div>

                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("In Service Date")}{" "}
                          <Tooltip content={t("in_service_date_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <DatePicker
                          className="form-control datepick"
                          selected={in_service_date}
                          onChange={(e) => setIn_service_date(e)}
                          placeholderText={"mm/dd/yyyy"}
                          showYearDropdown // year show and scrolldown alos
                          scrollableYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.in_service_date?.type === "required" &&
                          "In Service Date is required"}
                      </div> */}
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Mileage")}{" "}
                          <Tooltip content={t("Mileage_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Mileage")}
                          className="form-control"
                          type="text"
                          name="mileage"
                          maxLength="30"
                          id="id_mileage"
                          value={milage}
                          {...register5("mileage", {
                            onChange: (e) => {
                              setMilage(e.target.value);
                            },
                            // required: true,
                          })}
                        />
                        {/* <div className="invalid-feedback">
                        {errors4.mileage?.type === "required" &&
                          "Mileage is required"}
                      </div> */}
                      </div>

                    </div>
                  </div>
                  <button
                    type="submit"
                    className="border-0 btn btn-primary btn-gradient-primary btn-md"
                  >
                    {t("Save")}
                  </button>
                  &nbsp;&nbsp;
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn5} />

            </Form>

          }
        </SlidingPane>
        <SlidingPane
          className="some-custom-class sidepanebar"
          overlayClassName="custom-overlay"
          style={{width:'60 !important'}}
          isOpen={state6.isPaneOpen}
          title="Filter By"
          onRequestClose={() => {
            setState6({ isPaneOpen: false });
          }}

        >
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="col-form-label">{t("Item Number")}</label>
                  <AsyncSelect
                    defaultOptions
                    isClearable
                    placeholder={t("Search for Item Number (%for All)")}
                    value={itemSelect}
                    getOptionLabel={(e) => e.itemname}
                    getOptionValue={(e) => e.itemname}
                    loadOptions={loadOptionItem}
                    onInputChange={handelInputChangeItem}
                    onChange={handelChangeItem}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="col-form-label">{t("Serial Number")}</label>
                  <AsyncSelect
                    defaultOptions
                    isClearable
                    placeholder={t("Search for Serial number(%for All)")}
                    value={selectSerial}
                    getOptionLabel={(e) => e.serialnumber}
                    getOptionValue={(e) => e.serialnumber}
                    loadOptions={loadOptionsserial}
                    onInputChange={handelInputChangeSerial}
                    onChange={handelChangeserial}
                  />
                  <input type="hidden" id="contract_status" value="" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="col-form-label">
                    {t("Model")}
                  </label>
                  <AsyncSelect
                    defaultOptions
                    isClearable
                    placeholder={t("Search for Model(%for All)")}
                    value={selectModel}
                    getOptionLabel={(e) => e.model}
                    getOptionValue={(e) => e.model}
                    loadOptions={loadOptionsModel}
                    onInputChange={handelInputChangeModel}
                    onChange={handelChangemodel}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="col-form-label">
                    {t("Make")}
                  </label>
                  <AsyncSelect
                    defaultOptions
                    isClearable
                    placeholder={t("Search for Make(%for All)")}
                    value={selectMake}
                    getOptionLabel={(e) => e.make}
                    getOptionValue={(e) => e.make}
                    loadOptions={loadOptionsMake}
                    onInputChange={handelInputChangeMake}
                    onChange={handelChangeMake}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="col-lg-12 col-form-label">
                    {t("Manufacture")}
                  </label>
                  {/* <div className="col-lg-12"> */}
                  <AsyncSelect
                    defaultOptions
                    isClearable
                    placeholder={t("Search for Manufacture(%for All)")}
                    value={selectManu}
                    getOptionLabel={(e) => e.manufacturer}
                    getOptionValue={(e) => e.manufacturer}
                    loadOptions={loadOptionsManu}
                    onInputChange={handelInputChangeManu}
                    onChange={handelChangeManu}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  ></AsyncSelect>
                  {/* </div> */}
                  <input type="hidden" id="contract_status" value="" />
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <button
                type="button"
                className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={handelSearch}
                className="partyFilter add btn btn-primary ms-auto mb-0"
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
            <div style={{ marginTop: '10px' }}>
              <MaterialTable
                title="Inventory List"
                columns={[
                  {
                    title: "",
                    render: (rowData) => (
                      <input
                        type="checkbox"
                        checked={item_master_id === rowData.id}
                        onChange={() => handleTagClick(rowData)}
                      />
                    ),
                    sorting: false,
                  },
                  {
                    title: `${t("Item name")}`,
                    field: "itemname",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Item name")}</div>
                      <div>{rowData.itemname ? rowData.itemname : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Make")}`,
                    field: "make",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Make")}</div>
                      <div>{rowData.make ? rowData.make : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Model")}`,
                    field: "model",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Model")}</div>
                      <div>{rowData.model ? rowData.model : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Serial number")}`,
                    field: "serialnumber",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Serial number")}</div>
                      <div>{rowData.serialnumber ? rowData.serialnumber : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Manufacturer")}`,
                    field: "manufacturer",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Manufacturer")}</div>
                      <div>{rowData.manufacturer ? rowData.manufacturer : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Item Type")}`,
                    field: "item_type",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Type")}</div>
                      <div>{rowData.item_type ? rowData.item_type : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                  {
                    title: `${t("Status")}`,
                    field: "status",
                    render: rowData => <>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
                      <div>{rowData.status ? rowData.status : "None"}</div></>,
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left"
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12
                    }
                  },
                ]}
                detailPanel={[
                  {
                    render: rowData => <>
                      <div className="col-md-12" style={{ paddingLeft: "20px" }}>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Item Number')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.itemname ? rowData.itemname : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Status')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.status}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Description')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.description ? rowData.description : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Serial Number')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.serial_number ? rowData.serial_number : "None"}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Year of Manufacture')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.year ? rowData.year : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Manufacturer')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.manufacturer ? rowData.manufacturer : "None"}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Model')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.model ? rowData.model : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Make')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.make ? rowData.make : "None"}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label ">{t('Date placed in Service')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.date_place ? Helper.DateNormal(rowData.date_place) : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Life in Months')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.life_in_months ? rowData.life_in_months : "None"}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Net Book Value')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.netbookvalue ? Helper.Amount(rowData.netbookvalue) : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Original Cost')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.originalcost ? Helper.Amount(rowData.originalcost) : "None"}
                            </span>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Contract Number')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.contract_number ? rowData.contract_number : "None"}
                            </span>
                          </div>
                          <div className="col-xl-3">
                            <label className="col-lg-12 col-form-label">{t('Item Type')}</label>
                          </div>
                          <div className="col-xl-3">
                            <span className="col-lg-8 view-label p">
                              {rowData.item_type ? rowData.item_type : "None"}
                            </span>
                          </div>

                        </div>
                      </div></>,
                  },


                ]}
                data={inventory_option}
                options={{
                  selection: false,
                  search: false,
                  showSelectAllCheckbox: false,
                  // selectionProps: (rowData) => ({
                  //     checked: item_master_id === rowData.id,
                  //     disabled: item_master_id !== '' && item_master_id !== rowData.id,
                  //   }),
                }}

              // selectionProps={(rowData) => {
              //     const isChecked = item_master_id === rowData.id;
              //     const isDisabled = item_master_id !== '' && item_master_id !== rowData.id;
              //     return {
              //       checked: isChecked, 
              //       disabled: isDisabled, 
              //     };
              //   }}
              //   onSelectionChange={(rows) => {
              //     if (rows.length === 1) {
              //       setItem_master_id(rows[0].id); 
              //     } else {
              //       setItem_master_id(''); 
              //     }
              //   }}
              />
            </div>
          </div>
        </SlidingPane>
        <SlidingPane
          className="some-custom-class sidepanebarcontract"
          isOpen={state5.isPaneOpen}
          title="Add Payment Amount"
          subtitle=""
          onRequestClose={() => {
            setState5({ isPaneOpen: false });
            setRowsData([])
            setTermError("")
          }}
        >
          <Form
            role='form text-left'
            ref={form6}
            key={6}
            onSubmit={handleSubmit6(handlePayment)}
            method="POST"
            id="addAssetForm"
          >
            <>
              <div className="table-responsive-sm">
                <div className="row pt-3">
                  <div className="col-xl-6">
                    <label className="col-form-label">
                      {t("Payment Lines")}
                    </label>
                  </div>
                  <div className="col-xl-6">
                    <div className="text-right ">
                      <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={addTableRows}
                      >
                        + {t("ADD")}
                      </button>
                    </div>
                  </div>
                </div>
                <table
                  id="invoice"
                  className="table table-nowrap mb-0"
                >
                  <thead>
                    <th>
                      {t("Line no.")}{" "}
                      <Tooltip content={t("LineNumber_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Payment Type")}{" "}
                      <Tooltip content={t("PaymentType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Amount")}{" "}
                      <Tooltip content={t("Amount_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Payment Frequency")}{" "}
                      <Tooltip content={t("PaymentType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Total Terms")}{" "}
                      <Tooltip content={t("Totalterm_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Date From")}{" "}
                      <Tooltip content={t("Datefrom_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                    <th>
                      {t("Date To")}{" "}
                      <Tooltip content={t("Dateto_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </th>
                  </thead>
                  <tbody>
                    {rowsData.map((data, index) => (
                      <tr key={index}>
                        <td
                          style={{ width: '50px', fontSize: '12px' }}>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Line no.")} {" "} <Tooltip content={t("LineNumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip></div>

                          <div>
                            {index + 1}
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}
                            {" "} <Tooltip content={t("PaymentType_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <select
                              typeof="text"
                              className="form-control"
                              value={data.payment_type}
                              onChange={(evnt) =>
                                handlePaymentTypeChange(index, evnt.target.value)
                              }
                              name="payment_type"

                            >
                              <option value='Rent'>Rent</option>
                              {paymentType.map((key, i) => (
                                <option
                                  key={i}
                                  value={key.fee_name}
                                >
                                  {key.fee_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Amount")}
                            {" "} <Tooltip content={t("Amount_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <input
                              type="text"
                              placeholder="amount"
                              value={data.amount}
                              onChange={(evnt) => handelChangeAmount(index, evnt.target.value)}
                              name="termItem"
                              className="form-control"
                              style={{ width: '80px', fontSize: '12px' }}
                            />
                            <div className="invalid-feedback">
                              {errors.amount &&
                                "Amount is required"}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}
                            {" "} <Tooltip content={t("PaymentType_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <select
                              className="form-control"
                              value={data.payment_frequency}
                              disabled={
                                data.payment_type === 'Rent' ||
                                data.payment_type === 'Origination Fee' ||
                                data.payment_type === 'Documentation Fee'
                              }
                              onChange={(evnt) => handlePaymentFrequencyChange(index, evnt.target.value)}
                              name="payment_frequency"
                            >
                              {paymentFrequency.map((key, i) => (
                                <option
                                  key={i}
                                  value={key.label}
                                >
                                  {key.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Total Terms")}
                            {" "}<Tooltip content={t("Totalterm_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <input
                              type="text"
                              placeholder="Term"
                              value={paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time' ? 1 : data.no_of_payments}
                              disabled={paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time'}
                              onChange={(evnt) => handleTermChange(index, evnt.target.value)}
                              name="termItem"
                              style={{ width: '80px', fontSize: '12px' }}
                              className="form-control"
                            />
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Date From")}
                            {" "}<Tooltip content={t("Datefrom_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <input
                              disabled
                              type="text"
                              className="form-control"
                              name="date_from"
                              id="payment_enddate"
                              value={Helper.Dateview(data.start_date)}
                              style={{ width: '80px', fontSize: '12px' }}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Date To")}
                            {" "} <Tooltip content={t("Dateto_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </div>
                          <div>
                            <input
                              disabled
                              type="text"
                              className="form-control"
                              name="date_to"
                              id="payment_enddate"
                              value={Helper.Dateview(data.end_date)}
                              style={{ width: '80px', fontSize: '12px' }}
                            />
                          </div>
                        </td>
                        
                        <td>
                          <button
                            className="btn btn-outline-danger "
                            onClick={() => deleteTableRows(index)}
                          >
                            x
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {termError && <div className="invalid-feedback">{termError}</div>}
              </div>
              <button
                type="submit"
                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
              // disabled={disablebutton}
              >
                {t("Save")}
              </button>
            </>
            <CheckButton style={{ display: "none" }} ref={checkBtn6} />
          </Form>
        </SlidingPane>
        <div className="header mb-3 pt-2">
          <h5>{t("Create Contract Rental")}</h5>
        </div>
        <div className="row show_contract">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="success"></div>
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addPartyForm"
                >
                  {
                    <>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Contract Number")}{" "}
                              <Tooltip content={t("Contract_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                disabled={
                                  contract_number_method_disable === "Automatic"
                                    ? true
                                    : false
                                }
                                // value={contract_number}
                                onChange={(e) =>
                                  setContract_number(e.target.value)
                                }
                                type="text"
                                className="form-control"
                                name="contract_number"
                                id="contract_number"
                                {...register("contract_number", {
                                  onChange: (e) => {
                                    setContract_number(e.target.value);
                                  },
                                  required:
                                    contract_number_method_disable ===
                                      "Automatic"
                                      ? false
                                      : true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.contract_number?.type === "required" &&
                                  "Contract Number is required"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Customer")}{" "}
                              <Tooltip content={t("Customer_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-11">
                              <AsyncSelect
                                {...register("selectedValue", {
                                  required: true,
                                })}
                                defaultOptions={options}
                                isClearable
                                placeholder={t("Search for Customer(%for All)")}
                                options={options}
                                value={options.find(
                                  (option) => option.id === selectedValue
                                )}
                                getOptionLabel={(e) => e.customer_name}
                                getOptionValue={(e) => e.customer_name}
                                loadOptions={loadOptions}
                                onInputChange={handelInputChange}
                                onChange={handelChange}
                                name="selectedValue"
                              ></AsyncSelect>
                              <div className="invalid-feedback">
                                {errors.selectedValue && "Customer is required"}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => setState1({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "-5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <label className="col-lg-12 col-form-label required">
                            {t("Bill to Address")}{" "}
                            <Tooltip content={t("BilltoAddress_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-12">
                            {/* <select
                              value={address_id}
                              name="billto"
                              id="bill_address"
                              className="form-control input-lg form-select"
                              data-live-search="true"
                              title="Select Address"
                              {...register("billto", {
                                onChange: (e) => {
                                  setAdddressId(e.target.value);
                                },
                                required: true,
                              })}
                            >
                              <option value="">
                                ---{t("Select Address")}---
                              </option>
                              {address.map((key) => (
                                <option key={key.id} value={key.id}>
                                  {key.address_line_1},{" "}
                                  {key.address_line_2 !== ""
                                    ? `${key.address_line_2},`
                                    : ""}{" "}
                                  {key.city}, {key.state}, {key.country}
                                </option>
                              ))}
                            </select> */}
                            <AsyncSelect
                              {...register("billto", {
                                required: true,
                              })}
                              name="billto"
                              cacheOptions
                              defaultOptions={filterBill}
                              isClearable
                              isSearchable
                              options={filterBill}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              onChange={handleBillAddressChange}
                              loadOptions={loadOptionBillAdd}
                              value={filterBill.find((val) => val.value === address_id)}
                              placeholder={`${t("Search Address")}`}
                            />
                            <div className="invalid-feedback">
                              {errors.billto && "Address is required"}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Installed Location")}{" "}
                              <Tooltip content={t("InstallAddress_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-11">
                              {/* <select
                                name="address_id"
                                id="address_list"
                                className="form-control input-lg"
                                data-live-search="true"
                                title="Select Address"
                                value={reg_address1}
                                {...register("address_id", {
                                  onChange: (e) => {
                                    setReg_address1(e.target.value);
                                  },
                                  required: true,
                                })}
                              >
                                <option value="">
                                  ---{t("Select Install Address")}---
                                </option>
                                {reg_address.map((key) => (
                                  <option key={key.id} value={key.id}>
                                    {key.address_line_1},{" "}
                                    {key.address_line_2 !== ""
                                      ? `${key.address_line_2},`
                                      : ""}{" "}
                                    {key.city}, {key.state}, {key.country}
                                  </option>
                                ))}
                              </select> */}
                              <AsyncSelect
                                {...register("address_id", {
                                  required: true,
                                })}
                                name="address_id"
                                cacheOptions
                                defaultOptions={filteredOptions}
                                isClearable
                                isSearchable
                                options={filteredOptions}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={handleAddressChange}
                                loadOptions={loadOptionInstallAdd}
                                value={filteredOptions.find((val) => val.value === reg_address1)}
                                placeholder={`${t("Search Install Address")}`}
                              />
                              <div className="invalid-feedback">
                                {errors.address_id?.type === "required" &&
                                  "Install Address  is required"}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => setState2({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Start Date")}{" "}
                              <Tooltip content={t("StartDate_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <DatePicker
                                {...register("startdate", { required: true })}
                                className="form-control datepick"
                                selected={start_date}
                                onChange={(e) => handelStart_Date(e)}
                                name="startdate"
                                placeholderText={"mm/dd/yyyy"}
                                showYearDropdown // year show and scrolldown alos
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                              />
                              <div className="invalid-feedback">
                                {errors.startdate && "Start Date  is required"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Term")}{" "}
                              <Tooltip content={t("Term_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                type="text"
                                className="form-control"
                                name="contract_term"
                                id="contract_term"
                                {...register("contract_term", {
                                  required: "Term is required",
                                  max: {
                                    value: free.length !== 0 ? free[0].contract_term : 60,
                                    // message: `Term should not be more than ${free.length !== 0 ? free[0].contract_term : 60} for this user plan`,
                                    message: `Maximum term is 60 months. Please enter a term between 1 and 60.`,
                                  },
                                  validate: {
                                    positiveWholeNumber: (value) => {
                                      const numberValue = Number(value);
                                      if (isNaN(numberValue)) {
                                        return "Only numbers are allowed";
                                      } else if (numberValue % 1 !== 0) {
                                        return "Decimal numbers are not allowed";
                                      }
                                      else if (!Number.isInteger(numberValue) || numberValue <= 0) {
                                        return "Only positive numbers are allowed";
                                      }
                                      return true;
                                    }
                                  },
                                  onChange: (e) => {
                                    handelContract_term(e.target.value);
                                  },
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.contract_term &&
                                  errors.contract_term.message}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Vendor Name")}{" "}
                              <Tooltip content={t("VendorName_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-11">
                              {/* <select
                                className="form-control input-lg"
                                id="vendor_list"
                                name="vendorname1"
                                value={vendername1}
                                {...register("vendorname1", {
                                  onChange: (e) => {
                                    setVendorName1(e.target.value);
                                  },
                                  required: true,
                                })}
                              >
                                <option value="">
                                  ---{t("Select Vendor Name")}---
                                </option>
                                {vendor_name.map((key1) => (
                                  <option key={key1.id} value={key1.id}>
                                    {key1.customer_name}
                                  </option>
                                ))}
                              </select> */}
                              <AsyncSelect
                                {...register("vendorname1", {
                                  required: true,
                                })}
                                name="vendorname1"
                                cacheOptions
                                defaultOptions={filteredVendor}
                                isClearable
                                isSearchable
                                options={filteredVendor}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={handleVendorChange}
                                loadOptions={loadOptionVendorName}
                                value={filteredVendor.find((val) => val.value === vendername1)}
                                placeholder={`${t("Search Vendor Name")}`}
                              />
                              <div className="invalid-feedback">
                                {errors.vendorname1 && "Vendor is required"}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => setState4({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "-5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                        {asset_type.length === 1 ? (
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <label className="col-lg-6 col-form-label text-left required">
                              {t("Asset Type")}{" "}
                              <Tooltip content={t("Assettype_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              disabled
                              className="form-control"
                              value={asset_typesetting}
                            />
                          </div>
                        ) : (
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <label className="col-lg-6 col-form-label text-left required">
                              {t("Asset Type")}{" "}
                              <Tooltip content={t("Assettype_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              id="frequency"
                              className="form-control"
                              name="assettype"
                              value={asset_typeselection}
                              {...register("assettype", {
                                onChange: (e) => {
                                  setAssetTypeSelection(e.target.value);
                                },
                                required: true,
                              })}
                            >
                              <option value="">{"Select Asset Type"}</option>
                              <option value="Vehicle">{t("Vehicle")}</option>
                              <option value="Equipment">
                                {t("Equipment")}
                              </option>
                            </select>
                            <div className="invalid-feedback">
                              {errors.assettype && "Asset Type is required"}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-12">
                        <div className="form-group row">
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <label className="col-lg-6 col-form-label text-left required">
                              {t("Frequency")}{" "}
                              <Tooltip content={t("Frequency_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              id="frequency"
                              className="form-control"
                              name="frequency"
                              value={frequency}
                              {...register("frequency", {
                                onChange: (e) => {
                                  setFrequency(e.target.value);
                                },
                                required: true,
                              })}
                            >
                              <option value="">{t("Select Frequency")}</option>
                              <option value="Monthly">{t("Monthly")}</option>
                              <option value="Quarterly">
                                {t("Quarterly")}
                              </option>
                              <option value="Semi-annual">
                                {t("Semi-annual")}
                              </option>
                              <option value="Annual">{t("Annual")}</option>
                            </select>
                            <div className="invalid-feedback">
                              {errors.frequency && "Frequency is required"}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Asset Cost")}{" "}
                                <Tooltip content={t("VehicleCost_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <CurrencyInput
                                  id="input-example"
                                  className="form-control"
                                  {...register("vehiclecost", {
                                    required: "Asset cost is required",
                                    validate: {
                                      positive: (v) =>
                                        parseInt(v) > 0 || "Only positive numbers are allowed",
                                    },
                                  })}
                                  allowDecimals="false"
                                  value={vehicle_cost}
                                  onValueChange={(value) => setVehicle_cost(value)}
                                  name="vehiclecost"
                                  disableAbbreviations
                                />
                                <div className="invalid-feedback">
                                  {errors.vehiclecost && errors.vehiclecost.message}
                                </div>
                              </div>
                              {/* <div className="col-lg-1">
                                <img
                                  onClick={() => setState3({ isPaneOpen: true })}
                                  className=""
                                  style={{
                                    height: "20px",
                                    cursor: "pointer",
                                    marginLeft: "-5px",
                                  }}
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/iconplus.png"
                                  }
                                  alt="ADD"
                                ></img>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <label className="col-lg-6 col-form-label text-left required">
                            {t("Payment Rule")}{" "}
                            <Tooltip content={t("PaymentRule_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            id="paymentrule"
                            className="form-control"
                            name="paymentrule"
                            value={paymentrule}
                            {...register("paymentrule", {
                              onChange: (e) => {
                                setPaymentRule(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">{t("Select Payment Rule")}</option>
                            <option value="Advance">{t("Advance")}</option>
                            <option value="Arrears">{t("Arrears")}</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.paymentrule && "Payment Rule is required"}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-form-label required">
                              {t("Asset Description")}{" "}
                              <Tooltip content={t("AssetDesc_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-10">
                              <input
                                placeholder={t("Asset Description")}
                                className="form-control"
                                type="text"
                                name="asset_desc"
                                maxLength="200"
                                id="asset_desc"
                                value={asset_desc}
                                {...register("asset_desc", {
                                  onChange: (e) => {
                                    setAsset_desc(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.asset_desc?.type === "required" &&
                                  "Asset description is required"}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => { setState3({ isPaneOpen: true }) }}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "-5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                            <div
                              className="col-lg-1"
                               onClick={
                                  handleExitingInventory
                                  // setState3({ isPaneOpen: false });
                                  // setState6({ isPaneOpen: true });
                                }
                              style={{
                                color: "#b4b7c5",
                                paddingLeft: "0px",
                                cursor: "pointer",

                              }}
                            >
                              <img
                                src={
                                  process.env.PUBLIC_URL + "/static/images/ic-search.svg"
                                }
                                alt="Filter Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <label className="col-lg-6 col-form-label text-left required">
                            {t("Payment Start Date")}{" "}
                            <Tooltip content={t("StartDate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input className="form-control "
                            value={Helper.DateNormal(paymentstart_date)}
                            disabled
                          >
                          </input>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label text-left required">
                              {t("Payment Amount")}{" "}
                              <Tooltip content={t("PaymentAmount_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-11">
                              {rowsData.length > 1 ? (
                                <input
                                  className="form-control"
                                  value="Multiple"
                                  disabled={true}
                                />
                              ) : (
                                <CurrencyInput
                                  className="form-control"
                                  {...register("paymentamount", {
                                    required: isDisabled === true ? false : "Payment amount is required",
                                    validate: isDisabled === true ? false : { positive: (v) => (parseInt(v) > 0 || "Only positive numbers are allowed"), },
                                  })}
                                  onValueChange={(value) => setAmount(value)}
                                  name="paymentamount"
                                  id="input-example"
                                  allowDecimals="false"
                                  disableAbbreviations
                                  disabled={isDisabled}
                                />
                              )}
                              <div className="invalid-feedback">
                                {errors.paymentamount && errors.paymentamount.message}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => setState5({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "-5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                        {(rowsData.length !== 0 || (amount !== null || amount > 0 || amount === undefined)) && (
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            {/* <label className="col-lg-6 col-form-label text-left required">
                              <Tooltip content={t("StartDate_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label> */}
                            <MaterialTable
                              // tableRef={tableRef}
                              style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow:
                                  "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                              }}
                              title={<label className="col-lg-6 col-form-label text-left">
                                {t('Preview Payment Amounts')}{" "}
                                <Tooltip content={t("Preview Payment Amounts")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>}
                              columns={[
                                {
                                  title: `${t("No. of Payments")}`,
                                  field: "no_of_payments",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      {" "}
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("No. of Payments")}
                                      </div>
                                      <div>
                                        {rowData.no_of_payments}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Payment Type")}`,
                                  field: "payment_type",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Payment Type")}
                                      </div>{" "}
                                      <div >
                                        {rowData.payment_type}
                                      </div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("Amount")}`,
                                  field: "amount",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Amount")}
                                      </div>
                                      <div>
                                        {rowData.amount}
                                      </div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("Start Date")}`,
                                  field: "start_date",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {" "}
                                        {t("Start Date")}
                                      </div>
                                      <div>{Helper.DateNormal(rowData.start_date)}</div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("End Date")}`,
                                  field: "end_date",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("End Date")}
                                      </div>
                                      <div>
                                        {Helper.DateNormal(rowData.end_date)}
                                      </div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                              ]}
                              data={rowsData}
                              localization={{
                                toolbar: {
                                  searchPlaceholder: "Search Contracts",
                                },
                              }}
                              options={{
                                headerStyle: {
                                  backgroundColor: "white",
                                  color: "#245C7F",
                                  fontSize: 11,
                                },
                                rowStyle: (rowData, index) => {
                                  if (index % 2) {
                                    return { backgroundColor: "#fff" };
                                  }
                                },
                                sorting: true,
                                search: false,
                                toolbar: true,
                                paging: true,
                                pageSize: 3, // make initial page size
                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                pageSizeOptions: [3, 5, 10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                exportAllData: false,
                                exportButton: false,
                                actionsColumnIndex: -1,
                              }}
                            />
                            {/* <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>No. of Payments</th>
                                  <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Payment Type</th>
                                  <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Start Date</th>
                                  <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>End Date</th>
                                  <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rowsData.map((row, index) => (
                                  <tr key={index}>
                                    <td style={{ border: '1px solid #ddd' }}>{row.no_of_payments}</td>
                                    <td style={{ border: '1px solid #ddd' }}>{row.payment_type}</td>
                                    <td style={{ border: '1px solid #ddd' }}>{Helper.DateNormal(row.start_date)}</td>
                                    <td style={{ border: '1px solid #ddd' }}>{Helper.DateNormal(row.end_date)}</td>
                                    <td style={{ border: '1px solid #ddd' }}>{row.amount}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table> */}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-12">
                        <div className="form-group row">
                        </div>
                      </div>
                      {extrafiledcontract.length === 0 ? (
                        ""
                      ) : (
                        <h5
                          className="tc mt-4 cursor-pointer"
                          onClick={toggleFields}
                        >
                          {t("Additional Information")}{" "}
                          {isExpanded === true ? (
                            <FaAngleUp />
                          ) : (
                            <FaAngleDown />
                          )}
                        </h5>
                      )}
                      {isExpanded === true && (
                        <div className="form-group row">
                          {extrafiledcontract.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-6" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="form-control mb-1"
                                  name={"attribute" + index}
                                  type={key.datatype}
                                  placeholder={key.label}
                                  onChange={(e) =>
                                    onChangeextrafileds(e, index)
                                  }
                                />
                              </>
                            </div>
                          ))}
                        </div>
                      )}
                      <input
                        type="hidden"
                        value="Entered"
                        className="form-control"
                        name="status"
                        id="status"
                        disabled
                      />
                      <input
                        type="hidden"
                        className="form-control"
                        name="sign_date"
                        id="signdate"
                      />
                      <textarea
                        style={{ display: "none" }}
                        className="form-control"
                        id="description"
                        name="description"
                      ></textarea>
                      <input
                        type="hidden"
                        style={{ display: "none" }}
                        value="USD"
                        className="form-control"
                        name="currency"
                        id="currency"
                      />
                      <div className="text-left py-3">
                        <button
                          type="button"
                          onClick={handelClick}
                          className="btn-cancel-contract border-0 btn btn-secondary btn-gradient-primary btn-md"
                        >
                          {t("Cancel")}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="submit"
                          className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                          disabled={disablebutton}
                        >
                          {loading === false ? t("Save") : <ButtonLoading />}
                        </button>
                        &nbsp;&nbsp;
                        <span id="activeContract"></span>
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateRentalContract;
